import { Component, HostListener } from '@angular/core';
import { BaseComponent } from '@varsity/components';
import {
    LoggingService, TokenService, LocalStorageService,
    NotificationsService, PlatformService
} from "@varsity/services";
import { ToastController, PopoverController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the FooterComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'prevent-page-leave',
    templateUrl: 'prevent-page-leave.html'
})
export class PreventPageLeaveComponent extends BaseComponent {
    private message: string = "If you navigate away from this page, your tickets may be lost !";

    constructor(
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected toastCtrl: ToastController,
        protected popoverCtrl: PopoverController,
        protected platformService: PlatformService,
        protected iab: InAppBrowser,
    ) {

        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "PreventPageLeaveComponent");
    }

    @HostListener('window:beforeunload', ['$event'])
    doSomething($event) {
        $event.returnValue = this.message;
    }

    ngOnInit() {
        super.ngOnInit();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}



// WEBPACK FOOTER //
// ./src/components/prevent-page-leave/prevent-page-leave.ts